<div class="fullcontainer" >
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>Material Uplift Signoff</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/job-signoff/material-uplift/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    </div>
  </div>
  <label><strong>Supplier Invoice Number</strong></label>&nbsp;&nbsp;
  <input style='width: 20rem;display: inline-block;' class='form-control' type='text' [(ngModel)]="this.supplierInvoiceNumber"/>
  <button class='btn btn-primary' (click)='this.onSignOffButtonClicked()'>Sign off Selected</button>
  <br />
  <br />


  <div class='sheet' style='padding: 0.5rem;'>
    <div class='row'>
      <div class='col-md-4'>
        <label>Start Date</label>
        <input [(ngModel)]="this.searchFilters.startDate" class='form-control' type='date' />
      </div>
      <div class='col-md-4'>
        <label>End Date</label>
        <input [(ngModel)]="this.searchFilters.endDate"  class='form-control' type='date' />
      </div>
      <div class='col-md-4'>
        <label>Vehicle</label>
        <ng-select [(ngModel)]="this.searchFilters.vehicle" (change)='this.searchFilters.vehicle= $event;'>
          @for (item of this.vehicles; track item) {
            <ng-option [value]='item.registration'>{{ item.registration }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Customer</label>
        <ng-select [(ngModel)]="this.searchFilters.customer" (change)='this.searchFilters.customer = $event;'>
          @for (item of this.accounts; track item) {
            <ng-option [value]='item.name'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Subcontractor</label>
        <ng-select [(ngModel)]="this.searchFilters.subcontractor" (change)='this.searchFilters.subcontractor = $event;'>
          @for (item of this.subcontractors; track item) {
            <ng-option [value]='item.name'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Job Number</label>
        <input [(ngModel)]="this.searchFilters.jobNumber"  class='form-control' type='text' />
      </div>
      <div class='col-md-4'>
        <label>Tip Site</label>
        <ng-select [(ngModel)]="this.searchFilters.tipSite" (change)='this.searchFilters.tipSite = $event;'>
          @for (item of this.tips; track item) {
            <ng-option [value]='item.name'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Collection Ticket Number</label>
        <input [(ngModel)]="this.searchFilters.ticketNumber"  class='form-control' type='text' />
      </div>
      <div class='col-md-4'>
        <label>Supplier Invoice Number</label>
        <input [(ngModel)]="this.searchFilters.supplierInvoiceNumber"  class='form-control' type='text' />
      </div>
      <div class='col-md-4'>
        <label>Status</label>
        <select class='form-control' (change)='this.searchFilters.status = $event.target.value'>
          <option value=''>All Tickets</option>
          <option value='not'>Not Signed off</option>
          <option value='signed'>Signed off</option>
        </select>
      </div>
    </div>
    <br />
    <button class='btn btn-primary' type='button' (click)='this.search()'>Search</button>&nbsp;
    <button class='btn btn-danger' type='button' (click)='this.clear()'>Clear</button>
  </div>

  <br />

  <!-- <button class='btn btn-primary' (click)='this.onSignOffButtonClicked()'>Sign off Selected</button> -->
  <br />
  <br />

  <br />
  @if (this.selectedTickets.length > 0) {
    <p style='font-size:2rem'>
      <strong>Total Selected: {{ this.getSelectedDetails().total }} Total Qty: {{ this.getSelectedDetails().qty }} Total Price: {{this.getSelectedDetails().price }}</strong>
    </p>
  }

  <button class='btn btn-danger' (click)='this.clearSelected()'>Deselect All</button>



  <app-grid
    entity='material-uplift-ticket'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [backgroundSetter]='this.getRowColor'
    [checkboxSelector]='true'
    (checkboxSelected)='this.onCheckboxSelected($event)'
    [customDataSource]='this.getRecords.bind(this)'
    [showSearch]='false'
  ></app-grid>
